import ProductListing from "../../components/ProductListing/ProductListing";

function CollectionsPage() {
    return (
        <>
            <ProductListing />
        </>
    );
}

export default CollectionsPage;